export default __webpack_public_path__ + "static/media/more-icon.873d77bf.svg";